import { render, staticRenderFns } from "./UserThirdPartyConsent.vue?vue&type=template&id=15719ab0&scoped=true&"
import script from "./UserThirdPartyConsent.vue?vue&type=script&lang=js&"
export * from "./UserThirdPartyConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15719ab0",
  null
  
)

export default component.exports